import { CommonModule } from '@angular/common';
import { Component, input, output, signal } from '@angular/core';

@Component({
  selector: 'app-role-change-dialog',
  imports: [CommonModule],
  templateUrl: './role-change-dialog.component.html',
  styleUrl: './role-change-dialog.component.css',
})
export class RoleChangeDialogComponent {
user = input<any>(null);
isVisible = input<boolean>(false);
close = output<void>();
roleChanged = output<{userId: string ; newRole:string}>();
pendingRole = signal<string>('');

ngOnChanges(){
  if(this.user()){
    this.pendingRole.set(this.user().role);
  }
}
 selectRole(role: string) {
    this.pendingRole.set(role);
  }

  confirmRoleChange() {
    const user = this.user();
    if (!user) return;
    this.roleChanged.emit({ userId: user._id, newRole: this.pendingRole() });
    this.close.emit();
  }

  closeDialog() {
    this.close.emit();
  }

  getInitials(firstName: string, lastName: string): string {
    const first = firstName?.trim()?.[0] ?? '';
    const last = lastName?.trim()?.[0] ?? '';
    const initials = (first + last).toUpperCase();
    return initials || 'N/A';
  }

  getDisplayName(): string {
    const user = this.user();
    if (!user) return 'N/A';
    const first = user.firstName?.trim();
    const last = user.lastName?.trim();
    if (!first && !last) return 'N/A';
    return `${first ?? ''} ${last ?? ''}`.trim();
  }

  getProfileImage(): string | undefined {
    const user = this.user();
    if (!user) return undefined;
    const photos = user.profilePhotos as any[];
    if (!photos || photos.length === 0) return undefined;
    const primary = photos.find(p => p.isPrimary);
    return (primary ?? photos[0])?.signedUrl || undefined;
  }

}
